import { PatientSearchOptionWithBirthDate } from '../../../../../common/enums/patientSearchOptionWithBirthDate';
import { getObjectKeys } from '../../../../../common/utils/getObjectKeys';
import { translateKey } from '../../../../translate';
import { PatientSearchWithBirthdateAndOtherOptions } from './PatientSearchWithBirthdateAndOtherOptions';

export function PatientSearchWithoutIdentifierSocialSecurity() {
    return (
        <PatientSearchWithBirthdateAndOtherOptions
            defaultSearchOptionWithBirthDate={PatientSearchOptionWithBirthDate.insurance}
            header={translateKey('patientSso.findPatientNoBsn')}
            searchOptionsWithBirthDate={getRadioOptions()}
            thirdHeader={translateKey('patientSso.withoutBsnFindPatient')}
        />
    );

    function getRadioOptions() {
        const keys = getObjectKeys(PatientSearchOptionWithBirthDate);

        return keys.filter((key) => key !== 'identifierSocialSecurity') as PatientSearchOptionWithBirthDate[];
    }
}
